import { Injectable } from '@angular/core';

export type RentalPeriodType = 'day' | 'once' | 'twice';

@Injectable({
  providedIn: 'root'
})
export class RentalPeriodService {

  /**
   * Get the multiplier for a given rental period type and number of rental days
   *
   * @param rentalPeriodType - The type of rental period ('day', 'once', 'twice')
   * @param rentalDays - The number of rental days
   * @returns The multiplier to apply to the price
   */
  getMultiplier(rentalPeriodType: RentalPeriodType | string | undefined, rentalDays: number): number {
    switch (rentalPeriodType) {
      case 'day':
        // Per day: multiply by number of rental days
        return rentalDays;
      case 'once':
        // Per rental: charge once regardless of duration
        return 1;
      case 'twice':
        // Per pick-up/drop-off: charge twice (once at pickup, once at dropoff)
        return 2;
      default:
        // Default to per day if not specified
        return rentalDays;
    }
  }

  /**
   * Get display name for rental period type
   */
  getName(rentalPeriodType: RentalPeriodType | string | undefined): string {
    switch (rentalPeriodType) {
      case 'day':
        return 'Day';
      case 'once':
        return 'Rental';
      case 'twice':
        return 'Pick-up/drop-off';
      default:
        return 'Day';
    }
  }
}
